import React from 'react'
import { Link } from 'react-router-dom'
import Icon from 'react-icons-kit'
import { chevronRight } from 'react-icons-kit/feather'
import { Images } from '../../utils/Images'

// API sends last activity as "online 2 hours ago" / "offline 3 days ago"
export const isVisitorOnline = item =>
    typeof item?.isOnline === 'string' && item.isOnline.trim().toLowerCase().startsWith('online')

const VisitorCard = ({ item }) => {
    const image = item?.images?.[0]?.name || Images.NoImage
    const status = typeof item?.isOnline === 'string' ? item.isOnline.trim() : ''
    const online = isVisitorOnline(item)
    const lastSeen = status.replace(/^(online|offline)\s*/i, '')

    const meta = [
        item?.age ? `${item.age} yrs` : null,
        item?.city,
        item?.workingWith
    ].filter(info => info)

    return (
        <Link to={`/single-profile/${item?._id}`} className="visitor-card">
            <div className="visitor-avatar">
                <img src={image} alt={item?.name || 'Visitor'} />
                <span className={`presence ${online ? 'online' : 'offline'}`} />
            </div>

            <div className="visitor-info">
                <h6 className="visitor-name">{item?.name || 'Unknown'}</h6>
                {item?.profileId ? <span className="visitor-id">@{item.profileId}</span> : null}

                {meta.length ?
                    <div className="visitor-meta">
                        {meta.map((info, i) => <span className="chip" key={i}>{info}</span>)}
                    </div>
                    : null}

                {lastSeen ?
                    <span className={`visitor-seen ${online ? 'online' : ''}`}>
                        <span className="dot" /> {online ? 'Active now' : `Last seen ${lastSeen}`}
                    </span>
                    : null}
            </div>

            <span className="visitor-go">
                <Icon icon={chevronRight} size={16} />
            </span>
        </Link>
    )
}

export default VisitorCard
